import { Input } from "antd";
import React, { useCallback } from "react";
import { GlobalManualAdjustmentItem } from "src/modules/GlobalManualAdjustmentsManager/types/types";

type ISimpleInputCell = {
  item: GlobalManualAdjustmentItem;
  disabled?: boolean;
  defaultValue: string | number | undefined;
  onSave: (value: string, item: GlobalManualAdjustmentItem) => Promise<void>;
};

export const SimpleInputCell = React.memo(
  ({ item, disabled, defaultValue, onSave }: ISimpleInputCell) => {
    const handleSave = useCallback(
      async (
        e:
          | React.FocusEvent<HTMLInputElement>
          | React.KeyboardEvent<HTMLInputElement>,
      ) => {
        const value = (e.target as HTMLInputElement).value;
        await onSave(value, item);
      },
      [onSave, item],
    );

    return (
      <Input
        disabled={disabled}
        defaultValue={defaultValue}
        style={{ width: "100%" }}
        onBlur={handleSave}
        onPressEnter={handleSave}
      />
    );
  },
);
